window.addEventListener('DOMContentLoaded', function() {
    // let ajaxurl = lookeen.ajax_url;
    // // get ##nlsignup 
    // let nlsignup = document.querySelector('#nlsignup');
    // // email field 
    // let emailField = nlsignup.querySelector('input[name="email"]');

    // if (!nlsignup) return;

    // // on change email field, remove error class
    // emailField.addEventListener('change', function() {
    //     this.classList.remove('error');
    // });



    // // on submit
    // nlsignup.addEventListener('submit', function(e) {
    //    e.preventDefault();
    //    console.log('submit');
    //    console.log('making ajax call');
    //    // get name = "email" value
    //     let email = document.querySelector('input[name="email"]').value;
    //     // check if valid email or not empty
    //     if (!email || !email.includes('@')) {
    //         console.log('invalid email');
    //         // add error class to input
    //         nlsignup.querySelector('input[name="email"]').classList.add('error');
    //         return;
    //     }
    //     // make ajax call
    //     let data = new FormData();
    //     data.append('action', 'newsletter_signup');
    //     data.append('email', email);
    //     fetch(ajaxurl, {
    //         method: 'POST',
    //         body: data
    //     })
    //     .then(response => response.json())
    //     .then(data => {
    //         console.log(data);
    //         if (data.error) {
    //             console.log('error');
    //             // add error class to input
    //             nlsignup.querySelector('input[name="email"]').classList.add('error');
    //         } else {
    //             console.log('success');
    //             // add success class to input
    //             nlsignup.querySelector('input[name="email"]').classList.add('success');
    //             // reset form
    //             nlsignup.reset();
    //         }
    //     })
    // });


   

    var lang = jQuery("html").attr("lang");
    var newsletterEndpoint = window.location.origin + "/wp-content/themes/lookeen/php-endpoints/de-nlmail.php";
    var newsletterWaitText = '<span class="fa fa-spinner"></span>&nbsp;Bitte warten ...';
    if (lang === "en-US") {
      newsletterEndpoint = window.location.origin + "/wp-content/themes/lookeen/php-endpoints/en-nlmail.php";
      var newsletterWaitText = '<span class="fa fa-spinner"></span>&nbsp;Please wait ...';
    }


    jQuery("#nlsignup").on("submit", function (e) {
      jQuery("#resp-container")
        .removeClass("error")
        .removeClass("success")
        .addClass("info")
        .css("display", "block")
        .html(newsletterWaitText);
        e.preventDefault();

        var postData = jQuery("#nlsignup").serializeArray();
        jQuery.ajax({
          url: newsletterEndpoint,
          type: "POST",
          data: postData,
          dataType: "text",
          success: function (data, textStatus, jqXHR) {
            console.log(data);
            var res = JSON.parse(data);
            console.log(res);
            if (res["error"] == 1) {
              jQuery("#resp-container")
                .removeClass("info")
                .removeClass("success")
                .addClass("error")
                .css("display", "block")
                .html(res["msg"]);
            } else {
              ga("send", "event", "Button Send", "click", "Abo über Blog");
              jQuery("#resp-container")
                .removeClass("error")
                .removeClass("info")
                .addClass("success")
                .css("display", "block")
                .html(res["msg"]);
              jQuery("#nlsignup")[0].reset();
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            jQuery("#resp-container")
              .removeClass("success")
              .addClass("error")
              .css("display", "block")
              .html(errorThrown);
          },
        });
    });


});